import { faArrowRight } from "@fortawesome/pro-duotone-svg-icons";
import { faClock } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { getDetentionColorClasses } from "../../helpers/common";

export default function DetentionAlert({ data }) {
    const location = useLocation();
    const navigate = useNavigate();
    return (
        <Card className="shadow-sm rounded-xl h-full">
            <div className="flex justify-between items-baseline mb-2">
                <span className="text-[18px] font-semibold">
                    Detention Alert
                </span>
                <span className="text-[14px] text-primary hover:cursor-pointer" onClick={() => navigate("/detention")}>
                    See more <FontAwesomeIcon icon={faArrowRight} />
                </span>
            </div>
            <div className="space-y-1">
                {data?.map((item) => (
                    <div key={item?.containerID} className="shadow-md rounded-xl px-2 py-1">
                        <div className="flex justify-between">
                            <div className="flex items-start gap-3">
                                <span
                                    className={`w-3 h-3 opacity-60 rounded-full mt-3`}
                                    style={{ backgroundColor: getDetentionColorClasses(item?.daysToDetentionStart) }}
                                />
                                <div>
                                    <Button
                                        className="w-32 overflow-hidden whitespace-nowrap font-bold text-sm"
                                        type="primary"
                                        onClick={() => navigate("/shipment-gateway/shipment-details", {
                                            state: {
                                                pathname: location.pathname,
                                                containerID: item?.containerID,
                                                selectedContainerNum: item?.containerNum,
                                            }
                                        })}
                                    >
                                        {item?.containerNum}
                                    </Button>
                                    <div className="text-[14px] text-gray-500 mt-0.5">
                                        <span><FontAwesomeIcon icon={faClock} /> {Math.abs(item?.daysToDetentionStart)} days {item?.daysToDetentionStart >= 0 ? "remaining" : "overdue"}</span>
                                    </div>
                                </div>
                            </div>
                            {item?.daysToDetentionStart >= 0
                                ? null
                                : <div className="text-[18px] font-semibold flex items-center">
                                    ${item?.detentionFee?.toLocaleString()}
                                </div>
                            }
                        </div>
                    </div>
                ))}
            </div>
        </Card>
    );
}